<template>
  <div class="box">
    <div class="media-center">
      <figure>
        <img :src="contactPerson.img" :alt="contactPerson.name" loading="lazy"/>
      </figure>
    </div>
    <div class="media-content">
      <h1 class="title-card ">{{ contactPerson.name }}</h1>
      <hr class="line" />
      <div class="fpe">{{ contactPerson.function }}</div>
      <div class="fpe" :class="{'text-wrap': isTrainer}">{{ contactPerson.description }}</div>
      <div class="fpe">{{ contactPerson.phone }}</div>
      <div class="fpe">{{ contactPerson.email }}</div>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "ContactPersonCard",
  props: ["contactPerson", "isTrainer"],
  data() {
    return {};
  },
};
</script>

<style scoped>
/* @media screen  and (min-width: 300px){ */
.title-card {
  font-family: Acumin Variable Concept;
  font-weight: bold;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
  margin: auto;
  font-size: calc(20px + (70 - 20) * ((100vw - 600px) / (3840 - 600)));
  padding-bottom: 1vh;
  display: block;
  min-width: 1px;
}

.line {
  opacity: 0.85;
  width: 70%;
  margin: auto;
}

span {
  margin-top: 30px;
}

.fpe {
  text-align: center;
  font-weight: Light;
  font-family: Acumin Variable Concept;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 0.85;
  margin-top: 5%;
  font-size: calc(20px + (60 - 20) * ((100vw - 600px) / (3840 - 600)));
  /* overflow-wrap: break-word; */
  
}

.text-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.text-wrap:hover {
  color: #F37298;
  transition: 0.2s all;
}

.fpe:nth-child(6) {
  font-size: calc(15px + (40 - 15) * ((100vw - 600px) / (3840 - 600)));
}

img {
  border-radius: 50%;
  /* width: 20vw; */
  /* height: 20vw; */
  width: 40vw;
  margin: auto;
  margin-bottom: 15%;
  margin-top: 3%;
}
.box {
  align-items: center;
  background: #0d9599;
  border-radius: calc(40px + (100 - 40)*((100vw - 1024px)/(3840 - 1024)));
  border: 0.0625em solid mix(#fff, #abbaab, 20%);
  box-shadow: 0 0 1.7em 0 rgba(#abbaab, 0.55);
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  padding: 2vw;
  position:relative;
}
.media-content {
  width: 100%;
}

@media (max-width: 1024px) {
  .title-card {
    font-size: 13px;
    border-bottom: solid white 1px;
    padding-bottom: 3px;
    min-width: 1px;
  }
  span {
    margin-top: 20px;
  }
  .fpe {
    margin-top: 3%;
    font-size: 12px;
    text-overflow: none;
  }

  .fpe:nth-child(6) {
    font-size: 10px;
  }

  img {
    margin-bottom: 15%;
    margin-top: 3%;
    position: relative;
  }
  .box {
    align-items: center;
    background: #0d9599;
    border-radius: 30px;
    border: 0.0625em solid mix(#fff, #abbaab, 20%);
    box-shadow: 0 0 1.7em 0 rgba(#abbaab, 0.55);
    display: flex;
    flex-direction: column;
    min-width: 100px;
    max-width: 60vw;
    min-height: 60vw;
    justify-content: center;
    padding: 3vw;
  }
  hr.line {
    /* border: 1px solid white; */
    opacity: 0.65;
    margin-top: 0em;
    margin-bottom: 0em;
    width: 80% !important;
    display: none;
  }
}
</style>
